import { UseMutationResult } from '@tanstack/react-query';
import { createContext, useContext } from 'react';
import { RegisterContextType } from '@/context/RegisterContext';
import { PostRegisterCard, PostRegisterCardResponse } from './types';
import { FetchError } from '@/hooks/useApi';

export const RegisterContext = createContext<RegisterContextType>({
  isLoadingAni: false,
  queryErrorAni: null,
  ani: undefined,
  registrationCode: undefined,
  setRegistrationCode: () => {},
  isLoadingPaymentSession: false,
  queryErrorPaymentSession: null,
  paymentSession: undefined,
  postRegisterCard: {} as UseMutationResult<PostRegisterCardResponse, FetchError, PostRegisterCard, unknown>,
  setPaymentSessionId: () => {},
  resetPaymentSession: () => {},
  resetRegistrationCode: () => {}
});

export const useRegister = () => {
  const context = useContext(RegisterContext);

  vtlog('useRegister:', context);

  if (context === null) {
    throw new Error('useRegister must be used within a RegisterProvider');
  }

  return context;
};
